import { useEffect, useState } from 'react';
import {
  getWikiProject,
  listWikiPages,
  WikiPageSummary,
  WikiProject,
} from '../api/wiki';

export function ProjectHome({ pid }: { pid: string }) {
  const [project, setProject] = useState<WikiProject | null>(null);
  const [pages, setPages] = useState<WikiPageSummary[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void Promise.all([getWikiProject(pid), listWikiPages(pid, { limit: 100 })])
      .then(([proj, list]) => {
        if (cancelled) return;
        setProject(proj.project);
        setPages(list.pages);
      })
      .catch((e) => {
        if (!cancelled) setError((e as Error).message);
      });
    return () => {
      cancelled = true;
    };
  }, [pid]);

  if (error)
    return (
      <div style={{ padding: 24 }}>
        <a href="#/wiki">← Projects</a>
        <div className="banner banner-warning">{error}</div>
      </div>
    );
  if (!project) return <div style={{ padding: 24 }}>Loading…</div>;

  return (
    <div style={{ padding: 24 }}>
      <a href="#/wiki" style={{ marginBottom: 12, display: 'inline-block' }}>
        ← Projects
      </a>
      <h2 style={{ marginBottom: 4 }}>📚 {project.name}</h2>
      <div className="muted small" style={{ marginBottom: 16 }}>
        {project.description}
      </div>
      <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
        <a href={`#/wiki/p/${encodeURIComponent(pid)}/search`}>
          <button>Search</button>
        </a>
        <a href={`#/wiki/p/${encodeURIComponent(pid)}/query`}>
          <button>Ask a question</button>
        </a>
        <a href={`#/wiki/p/${encodeURIComponent(pid)}/log`}>
          <button>Activity log</button>
        </a>
      </div>
      <h3>Pages</h3>
      {pages.length === 0 ? (
        <div className="muted">
          No pages yet. Tag a document with "Wikify this" in the Documents
          gallery, or call <code>write_markdown_file</code> with{' '}
          <code>wikify: true</code>. Ingestion runs once per minute.
        </div>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {pages.map((p) => (
            <li key={p.id} style={{ padding: '6px 0' }}>
              <a
                href={`#/wiki/p/${encodeURIComponent(pid)}/page/${encodeURIComponent(p.slug)}`}
                style={{ color: 'inherit' }}
              >
                <strong>{p.title}</strong>{' '}
                <span className="muted small">[{p.kind}] {p.slug}</span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
